import { DefaultTheme } from 'styled-components';

export const defaultTheme: DefaultTheme = {
    name: 'default',
    background: {
        body: '#FFF',
        text: '#363537',
        toggleBorder: '#FFF',
        theme: '',
        revertTheme: '',
        apricot: '#FFCDB2',
        melon: '#FFB4A2',
        pink: '#F4DBDE',
        lavender: '#6D6875',
        white: '#FFFFFF',
        peach: '#FFBE9C',
        border: '#BCBEC0',
        selected: '#F4DBDE',
        input: '#FFF',
        lightGray: '#E6E7E8',
        table: '#E6E7E8',
        tileBackground: '#F4DBDE',
        transparent: 'transparent',
    },
    text: {
        red: '#FF0000',
        white: '#FFFFFF',
        black: '#000000',
        lavender: '#6D6875',
        selected: false,
    },
    button: {
        link: '#000',
    },
};

export const whiteContrast: DefaultTheme = {
    name: 'whiteContrast',
    background: {
        body: '#FFF',
        text: '#363537',
        toggleBorder: '#FFF',
        theme: '#FFFFFF',
        revertTheme: '#000000',
        apricot: '#FFFFFF',
        melon: '#FFFFFF',
        pink: '#000',
        lavender: '#FFFFFF',
        white: '#FFFFFF',
        peach: '#000000',
        border: '#000000',
        selected: '#000000',
        onHoverColor: '#FFF',
        input: '#FFF',
        lightGray: '#FFF',
        table: '#fff',
        tileBackground: '#FFFFFF',
        transparent: '#FFFFFF',
    },
    text: {
        red: '#000',
        white: '#000000',
        black: '#000000',
        lavender: '#000000',
        selected: '#FFFFFF',
        input: '#FFF',
    },
    button: {
        link: '#fff',
    },
};

export const blackContrast: DefaultTheme = {
    name: 'blackContrast',
    background: {
        body: '#FFF',
        text: '#363537',
        toggleBorder: '#FFF',
        theme: '#000000',
        revertTheme: '#FFFFFF',
        apricot: '#000000',
        melon: '#000000',
        pink: '#fff',
        lavender: '#FFFFFF',
        white: '#000000',
        peach: '#FFFFFF',
        border: '#FFFFFF',
        selected: '#FFFFFF',
        onHoverColor: '#000000',
        input: '#000',
        lightGray: '#000000',
        table: '#000',
        tileBackground: '#000000',
        transparent: '#000000',
    },
    text: {
        red: '#FFF',
        white: '#FFFFFF',
        black: '#FFFFFF',
        lavender: '#FFFFFF',
        selected: '#000000',
    },
    button: {
        link: '#000',
    },
};

export const pinkContrast: DefaultTheme = {
    name: 'pinkContrast',
    background: {
        body: '#FFF',
        text: '#363537',
        toggleBorder: '#FFF',
        theme: '#F4DBDE',
        revertTheme: '#000000',
        apricot: '#F4DBDE',
        melon: '#F4DBDE',
        pink: '#000',
        lavender: '#F4DBDE',
        white: '#F4DBDE',
        peach: '#000000',
        border: '#000000',
        selected: '#000000',
        onHoverColor: '#F4DBDE',
        input: '#FFF',
        lightGray: '#fff',
        table: '#F4DBDE',
        tileBackground: '#F4DBDE',
        transparent: '#F4DBDE',
    },
    text: {
        red: '#000',
        white: '#000000',
        black: '#000000',
        lavender: '#000000',
        selected: '#F4DBDE',
    },
    button: {
        link: '#FFC0CB',
    },
};

export const pinkBlackContrast: DefaultTheme = {
    name: 'pinkBlackContrast',
    background: {
        body: '#FFF',
        text: '#363537',
        toggleBorder: '#FFF',
        theme: '#000000',
        revertTheme: '#F4DBDE',
        apricot: '#000000',
        melon: '#000000',
        pink: '#F4DBDE',
        lavender: '#000000',
        white: '#000000',
        peach: '#F4DBDE',
        border: '#F4DBDE',
        selected: '#F4DBDE',
        onHoverColor: '#000000',
        input: '#000',
        lightGray: '#F4DBDE',
        table: '#000',
        tileBackground: '#000000',
        transparent: '#000000',
    },
    text: {
        red: '#FFC0CB',
        white: '#FFC0CB',
        black: '#FFC0CB',
        lavender: '#FFC0CB',
        selected: '#000000',
    },
    button: {
        link: '#000',
    },
};

export const accessibilityThemes = {
    default: defaultTheme,
    'black-white': whiteContrast,
    'white-black': blackContrast,
    'black-pink': pinkContrast,
    'pink-black': pinkBlackContrast,
};
